import { render, staticRenderFns } from "./biography.vue?vue&type=template&id=f3af2460&scoped=true"
import script from "./biography.vue?vue&type=script&lang=js"
export * from "./biography.vue?vue&type=script&lang=js"
import style0 from "./biography.vue?vue&type=style&index=0&id=f3af2460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af2460",
  null
  
)

export default component.exports